import React, { Component } from "react";

class CookiePolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scriptLoaded: false, 
    };
  }

  componentDidMount() {
    console.log("Cookie policy doc");

    // Create a script element
    const script = document.createElement("script");
    script.id = "termly-jssdk";
    script.src = "https://app.termly.io/embed-policy.min.js";
    script.type = "text/javascript";
    script.async = true;

    document.body.appendChild(script);
    this.state.scriptLoaded = true;
    this.setState(this.state);
  }

  render() {
   

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 999,
        }}
      >
        <div
          name="termly-embed"
          data-id="85ec2b84-5b92-490c-b0e4-11256dda37fc"
          style={{
            position: "relative",
            backgroundColor: "white",
            border: "1px solid #ccc",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            padding: "35px",
            zIndex: 1000,
            width: "70vw",
          }}
        ></div>
      </div>
    );
  }
}

export default CookiePolicy;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/CookiePolicy.js